import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IProfileRepository } from '../../repositories/interfaces/iProfileRepository';

export interface IResetParentalLockOTPUseCase {
    generateOTP(apiKey: string, identityToken: string, username: string, lang: string): Promise<any>;
    verifyOTP(apiKey: string, identityToken: string, otp: string, verificationGuid: string): Promise<any>;
    resetWithOTP(
        apiKey: string,
        identityToken: string,
        pin: string,
        options?: { verificationGuid?: string; currentParentalLockPin?: string }
    ): Promise<any>;
}

export class ResetParentalLockOTPUseCase implements IResetParentalLockOTPUseCase {
    private get profileRepository(): IProfileRepository {
        return container.resolve<IProfileRepository>(DI.REPOSITORIES.IProfileRepository);
    }

    async generateOTP(apiKey: string, identityToken: string, username: string, lang: string): Promise<any> {
        const result = await this.profileRepository.resetParentalLockGenerateOTP(apiKey, identityToken, username, lang);
        return result.data;
    }

    async verifyOTP(apiKey: string, identityToken: string, otp: string, verificationGuid: string): Promise<any> {
        const result = await this.profileRepository.resetParentalLockVerifyOTP(
            apiKey,
            identityToken,
            otp,
            verificationGuid
        );
        return result.data;
    }

    async resetWithOTP(
        apiKey: string,
        identityToken: string,
        pin: string,
        options: { verificationGuid?: string; currentParentalLockPin?: string } = {}
    ): Promise<any> {
        const result = await this.profileRepository.resetParentalLockWithOTP(apiKey, identityToken, pin, options);
        return result.data;
    }
}
